import { c, IllustrationFrame, sc, type IllustrationProps } from './Illustration';

/** 404 and error states. A single balloon drifting off. */
export function LostBalloon(props: IllustrationProps) {
  return (
    <IllustrationFrame {...props}>
      <path
        d="M96 76c-8 18 10 28-4 44-10 12 4 20-6 30"
        style={{ fill: 'none', stroke: sc('fg.subtle'), strokeWidth: 2, strokeLinecap: 'round' }}
      />
      <ellipse
        cx="96"
        cy="46"
        rx="26"
        ry="31"
        transform="rotate(12 96 46)"
        style={{ fill: c('berry.400') }}
      />
      <path d="M90 76h9l-4 6z" style={{ fill: c('berry.500') }} />
      <ellipse
        cx="86"
        cy="34"
        rx="5"
        ry="10"
        transform="rotate(25 86 34)"
        style={{ fill: c('neutral.0'), opacity: 0.45 }}
      />
      <path
        d="M30 112c6-8 18-8 22 0 6-4 14 0 12 6H26c-2-4 0-6 4-6z"
        style={{ fill: c('blue.100') }}
      />
      <path
        d="M112 128c4-6 14-6 16 0 4-3 10 0 9 5h-28c-1-3 1-5 3-5z"
        style={{ fill: c('blue.100') }}
      />
      <circle cx="40" cy="40" r="3" style={{ fill: c('gold.400') }} />
      <circle cx="136" cy="96" r="2.5" style={{ fill: c('gold.400') }} />
    </IllustrationFrame>
  );
}
